import { RouteUrlBucket } from "cruzo";
import { BookExercisesComponent } from "site/components/book-exercises/book-exercises.component";
import { BooksComponent } from "site/components/books/books.component";
import { ExerciseComponent } from "site/components/exercise/exercise.component";
import { PaymentStatusComponent } from "site/components/payment-status/payment-status.component";
import { PromoComponent } from "site/components/promo/promo.component";

export const routerUrlBucket = new RouteUrlBucket({
  main: {
    url: '/',
    componentSelectorUnbox: () => PromoComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  books: {
    url: '/books',
    componentSelectorUnbox: () => BooksComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  book_exercises: {
    url: '/books/:bookId',
    componentSelectorUnbox: () => BookExercisesComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  exercise: {
    url: '/books/:bookId/:exerciseId',
    componentSelectorUnbox: () => ExerciseComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  exercise_edit: {
    url: '/books/:bookId/:exerciseId/edit',
    loadResources: () => {
      return import("site/components/exercise-editor/exercise-editor.component")
    },
    componentSelectorUnbox: () => "exercise-editor-component",
    routeSelectorUnbox: () => ".section"
  },
  books_editor: {
    url: '/editor/books',
    loadResources: () => {
      return import("site/components/books-editor-list/books-editor-list.component")
    },
    componentSelectorUnbox: () => "books-editor-list-component",
    routeSelectorUnbox: () => ".section"
  },
  book_editor: {
    url: '/editor/books/:bookId',
    loadResources: () => {
      return import("site/components/book-editor/book-editor.component")
    },
    componentSelectorUnbox: () => "book-editor-component",
    routeSelectorUnbox: () => ".section"
  },
  rules: {
    url: '/rules',
    loadResources: () => {
      return import("site/components/rules-list/rules-list.component")
    },
    componentSelectorUnbox: () => "rules-list-component",
    routeSelectorUnbox: () => ".section"
  },
  vocabulary: {
    url: '/vocabulary',
    loadResources: () => {
      return import("site/components/vocabulary-list/vocabulary-list.component")
    },
    componentSelectorUnbox: () => "vocabulary-list-component",
    routeSelectorUnbox: () => ".section"
  },
  rule_edit: {
    url: '/rules/:ruleId/edit',
    loadResources: () => {
      return import("site/components/rule-editor/rule-editor.component")
    },
    componentSelectorUnbox: () => "rule-editor-component",
    routeSelectorUnbox: () => ".section"
  },
  payment_return: {
    url: '/payment/return',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  payment_fail: {
    url: '/payment/fail',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  payment_already_confirmed: {
    url: '/payment/already-confirmed',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  owner_payments: {
    url: '/owner/payments',
    loadResources: () => {
      return import("site/components/owner-payments/owner-payments.component")
    },
    componentSelectorUnbox: () => "owner-payments-component",
    routeSelectorUnbox: () => ".section"
  },
})